import { slices } from "@/constants/sliceNames";
import {
  requestMonitoringAlertsStatus,
  requestSingleMonitoringAlertStatus,
  requestCreateMonitoringAlertStatus,
  requestDeleteMonitoringAlertStatus,
  requestUpdateMonitoringAlertStatus,
} from "@/store/effects/monitoring/monitoringAlerts-effects";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  /**@type {HoyaAlert[]} */
  alerts: [],

  /**@type {number} */
  recordsCount: 0,

  /**@type {boolean} */
  loading: false,

  /**@type {HoyaAlert} */
  item: {},

  /**@type {boolean} */
  updateLoading: false,
};

const hoyaAlertsSlice = createSlice({
  name: slices.monitoringAlerts,
  initialState,
  extraReducers: {
    ...requestMonitoringAlertsStatus,
    ...requestSingleMonitoringAlertStatus,
    ...requestCreateMonitoringAlertStatus,
    ...requestDeleteMonitoringAlertStatus,
    ...requestUpdateMonitoringAlertStatus,
  },
});

const { actions, reducer } = hoyaAlertsSlice;

export { actions, initialState };

export default reducer;
